import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";
import Button from "../ui/Button";
import { useTabs } from "../hooks/useTabs";
import { getSignal } from "../App";

export default function Prompt(props) {

    const { controller = "", route = "", enterOverwrite = false, description = "", value = "", width = 234, inputProps = {}, button = false, callback = () => { }, permission = false, login = true } = props;

    const [init, setInit] = useState(true);
    const [id, setId] = useState(null);

    const signal = getSignal();

    const fields = [
        { key: "prompt", value: value },
        { key: "submit", value: "" },
    ]

    const { tabs, setTabs, index, help, update, setIndex, editProps, next, prev, refs, getVal } =
        useTabs(fields, "prompt");


    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(id, "enter") } },
    ]

    useEffect(() => {
        if (refs?.current[index]) {
            refs.current[index].focus();
        }
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions, id])

    return (
        <>
            <div style={{ "width": (width) ? width + "px" : "auto" }}>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    {(description && <Label>{description}</Label>)}

                    <Input style={{ "textAlign": "center" }} onEnter={(e) => {enterOverwrite ? callback(getVal("prompt")) : callback(parseInt(e))}} onChange={(e) => setId(e)} {...editProps("prompt")} {...inputProps} />
                    <Button onClick={() => callback(getVal("prompt"))} className="ui-button small" type="primary" {...editProps("submit")}>Submit</Button>
                </Space>
            </div>
            {/* <small><pre>{JSON.stringify(signal.value, null, 2)}</pre></small> */}
        </>
    )
}